<mat-form-field [disabled]="disabled" class="full-width">
  <mat-label>Codici Ateco</mat-label>

  <mat-chip-grid
    #chipGrid
    [required]="required()"
    [disabled]="disabled"
    aria-label="Selezione Codici Ateco"
  >
    @for (ateco of codiciAtecoSel; track ateco._id) {
      <mat-chip-row (removed)="remove(ateco._id)" [editable]="!disabled" [removable]="!disabled">
        {{ ateco._id }} - {{ ateco.desc }}

        <button matChipRemove *ngIf="!disabled" [attr.aria-label]="'Rimuovi ' + ateco._id">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>

  <input
    #codAtecoInput
    placeholder="Cerca Ateco (codice o descrizione)..."
    [formControl]="codiciAtecoCtrl"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="auto"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
  />

  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="selected($event)"
    panelClass="ateco-autocomplete-panel"
  >
    @for (ateco of filteredAteco | async | slice: 0 : 50; track ateco._id) {
      <mat-option [value]="ateco">
        <strong>{{ ateco._id }}</strong> - {{ ateco.desc }}
      </mat-option>
    }
    @if (showAltriRecordDisponibili) {
      <div class="limit-info">
        Numero record limitati, modifica il filtro per restringere la ricerca.
      </div>
    }
  </mat-autocomplete>

  @if (isErrorState()) {
    <mat-hint class="error-hint">Almeno un codice Ateco è obbligatorio</mat-hint>
  }
</mat-form-field>
